import { useEffect, useMemo, useState } from 'react';

import BannerButton from 'components/home/cta-sticky-banner/banner-button';
import LeadForm from 'components/home/lead-form/lead-form';
import LeftIcon from 'core/icons/left-icon';
import propTypes from 'prop-types';
import styles from 'styles/StickyBanner.module.scss';
import { useGetOffsetStatus } from 'hooks';
import { useOpenNav } from 'context/OpenNavContext';
import { usePageInfo } from 'context/PageInfoContext';
import { useTranslations } from 'next-intl';

const CtaStickyBanner = ({ hideMobile = false }) => {
    const { pageInfo } = usePageInfo();
    const [offsetStatus, setOffsetStatus] = useState(false);
    const { openNav } = useOpenNav();
    const [showLeadForm, setShowLeadForm] = useState(false);
    const [isHided, setHided] = useState(false);
    const [carList, setCarList] = useState([]);
    const t = useTranslations('swiper');

    useGetOffsetStatus((status) => {
        setOffsetStatus(status);
    }, 20);

    const showLeadFormCondition = pageInfo.page_context.car_brand_list !== null;
    const toggleStyle = {
        backgroundColor: !offsetStatus && 'transparent',
        transform: `translateY(${!isHided ? 0 : 80}px)`,
        boxShadow: offsetStatus && '0px -5px 8px 1px rgba(0, 0, 0, 0.25)',
        opacity: openNav ? 0 : 1,
        transition: 'all ease-in .5s'
    };

    /**
     * This style handle the rotation of the Banner Arrow button
     */
    const arrowStyle = {
        transition: 'all 0.3s ease-in',
        transform: isHided ? 'rotate(90deg)' : 'rotate(-90deg)'
    };

    /**
     * This style add an extra padding when there is no scroll offset, or the Menu is not opened
     */
    const buttonTopOffsetStyle = {
        transition: 'all ease-in .3s',
        backgroundColor: !offsetStatus && 'transparent',
        paddingBottom: offsetStatus || openNav ? '0' : '2.5vh'
    };

    function openLeadForm () {
        setHided(true);
        setShowLeadForm(true);
    }

    function closeLeadForm () {
        setHided(false);
        setShowLeadForm(false);
    }

    const buttonProps = showLeadFormCondition ?
        {
            onClick: openLeadForm
        } :
        { href: t('compara-link') };

    const styleCache = useMemo(() => ({ buttonTopOffsetStyle, arrowStyle, toggleStyle, buttonProps }),
        [offsetStatus, openNav]);

    useEffect(() => {
        setHided(openNav);
    }, [openNav]);

    useEffect(() => {
        if (!offsetStatus) {
            setHided(false);
        }
    }, [offsetStatus]);

    useEffect(() => {
        if (pageInfo.page_context.car_brand_list !== null) {
            setCarList(pageInfo.page_context.car_brand_list);
        }
    }, []);

    return (
        <div style={{ display: hideMobile && !offsetStatus ? 'none' : '' }}>
            <LeadForm isVisible={showLeadForm} closeHandler={closeLeadForm} carList={carList} />
            <div
                style={styleCache.toggleStyle}
                className={styles.sticky_banner__container}
            >
                <div
                    className={styles.sticky_banner__wrapper}
                    style={styleCache.buttonTopOffsetStyle}
                >
                    <BannerButton
                        colorSchema={offsetStatus > 0 ? 'white' : 'pink'}
                        buttonProps={styleCache.buttonProps}
                    />

                    {/** This renders the Banner top arrow button, when the scroll offset is false will hide the arrow */}
                    {offsetStatus && (
                        <div
                            className={styles.sticky_banner__selector}
                            onClick={() => !openNav && setHided((st) => !st)}
                        >
                            <LeftIcon style={styleCache.arrowStyle} fill="white" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

CtaStickyBanner.propTypes = {
    hideMobile: propTypes.bool
};

export default CtaStickyBanner;
